export const APP_NAME = 'ContractIQ'
export const APP_TAGLINE = 'Construction Contract Intelligence Agent'

/** Displayed in the chat footer. Bump the minor number with every pull request. */
export const APP_VERSION = 'v1.1'

function required(name: keyof ImportMetaEnv): string {
  const value = import.meta.env[name]
  if (!value) {
    throw new Error(
      `Missing build-time environment variable ${name}. Set it in web/.env.production (or web/.env.local for local dev).`,
    )
  }
  return value
}

export const config = {
  clientId: required('VITE_AAD_CLIENT_ID'),
  tenantId: required('VITE_AAD_TENANT_ID'),
  directConnectUrl: required('VITE_COPILOT_DIRECT_CONNECT_URL'),
} as const

/**
 * Base URL of the MarkItDown conversion API. Optional on purpose — when it is
 * unset (local dev, or if the service is retired) the app falls back to parsing
 * documents in the browser instead of breaking.
 */
export const convertApiUrl = import.meta.env.VITE_CONVERT_API_URL?.replace(/\/$/, '') ?? ''

/** Delegated scope for the conversion API. Published by scripts/expose-api-scope.ps1. */
export const CONVERT_API_SCOPE = `api://${config.clientId}/Documents.Convert`

/**
 * Delegated scope required to invoke a Copilot Studio agent through the
 * Dataverse-backed authenticated endpoint.
 */
export const COPILOT_STUDIO_SCOPE = 'https://api.powerplatform.com/CopilotStudio.Copilots.Invoke'

export const SUGGESTED_PROMPTS = [
  'Summarize the key risks in this subcontract.',
  'What are the notice requirements for a change order?',
  'Compare these indemnity terms to our standard position.',
  'Does this contract include a pay-if-paid clause?',
]
